// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./shared/controllers"
import "@rails/activestorage"
import "./channels"
import setupCSRFToken from "./config/setupCSRFToken"
import turboPrepareBeforeCache from "./config/turboPrepareBeforeCache"
import feather from "feather-icons"
import toastr from "toastr"
import "bootstrap"
import _ from "lodash"

// Make toastr globally available
window.toastr = toastr

// Setup CSRF token for axios globally
setupCSRFToken();

// Handle Turbo events
const container = document.querySelectorAll('[data-function="turbo-autoload"]')[0]

document.addEventListener('turbo:load', function(){
  if (typeof BSN !== 'undefined') {
    BSN.initCallback(container);
  }
  
  // Setup CSRF token
  setupCSRFToken();
  
  // Replace feather icons
  feather.replace();
}, false);

document.addEventListener("turbo:before-cache", function() {
  turboPrepareBeforeCache();
});
